module.exports = __webpack_public_path__ + "img/cover_bg.4cec0a3a.png";